import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface ToastProps {
  visible: boolean;
}
export function Toast({
  visible
}: ToastProps) {
  return <AnimatePresence data-id="element-128">
      {visible && <motion.div initial={{
      y: 100,
      x: '-50%',
      opacity: 0
    }} animate={{
      y: 0,
      x: '-50%',
      opacity: 1
    }} exit={{
      y: 100,
      x: '-50%',
      opacity: 0
    }} transition={{
      type: 'tween',
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} className="fixed bottom-[30px] left-1/2 z-[500] whitespace-nowrap bg-[#1a1a1a] px-[30px] py-[14px] text-[12px] uppercase tracking-[2px] text-white" data-id="element-129">
          ✓ Producto agregado al carrito
        </motion.div>}
    </AnimatePresence>;
}